<style scoped>
</style>

<template>
	<b-modal :id="name" :ref="name" no-close-on-esc no-close-on-backdrop hide-header-close>
		<span slot="modal-title">
			<slot name="title">{{options ? options.title : 'Potwierdzenie'}}</slot>
		</span>
		<slot name="message">
			{{ options && options.message }}
		</slot>
		<slot name="additionalContent"></slot>
		<slot name="additional-content"></slot>
		<div slot="modal-footer">
			<slot name="confirm-button">
				<b-button variant="outline-success" @click="ok()" v-hnx-style.5ml>
					<i class="fa fa-check" v-hnx-style.3mr></i>
					<slot name="ok-label">{{options ? options.okLabel : 'OK'}}</slot>
				</b-button>
			</slot>
			<slot name="cancel-button">
				<b-button variant="outline-warning" @click="cancel()" v-hnx-style.5ml>
					<i class="fa fa-times" v-hnx-style.3mr></i>
					<slot name="cancel-label">{{options ? options.cancelLabel : 'Anuluj'}}</slot>
				</b-button>
			</slot>
		</div>
	</b-modal>
</template>

<script>
import uniqueId from 'lodash/uniqueId';
import { defer } from 'q';

export default {
	data() {
		return {
			internal: {},
			name: uniqueId('hnx-confirm-modal-')
		};
	},
	
	props: {
		options: {
			type: Object,
			default: null
		}
	},
	
	methods: {
		ok() {
			this.$refs[this.name].hide();
			this.internal.modalCloseDeferred.resolve();
		},

		cancel() {
			this.$refs[this.name].hide();
			this.internal.modalCloseDeferred.reject();
		},
		
		open() {
			this.$refs[this.name].show();
			this.internal.modalCloseDeferred = defer();
			return this.internal.modalCloseDeferred.promise;
		},
		
		close() {
			this.ok();
		},
		
		dismiss() {
			this.cancel();
		}
	}
};
</script>
